import React, { useEffect, useState } from "react";
import { Alert, Button, Container, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { NavLink } from "react-router-dom";

import { ITrailer } from "../../../types/trailer";
import { IEmployeeTilsAccess } from "../../../types/employee";
import { ISelectOption } from "../../../types/list";

import { AppConfig } from "../../../config/appConfig";
import { useUserContext } from "../../../contexts/userContext";

import { TrailerService } from "../../../services/trailerService";
import { UtilityService } from "../../../services/utilityService";

import Navigation from "../../../components/header";
import PermissionGate from "../../permissionGate";
import Spinner from "../../spinner";
import TrailerTable from "../../tables/trailerTable";

import "../../../styles/entity/trailerList.scss";

const TrailerList = () => {
	const userContext = useUserContext();
	const [gridView, setGridView] = useState<ITrailer[]>();

	//Filtering
	const [customerOptions, setCustomerOptions] = useState<IEmployeeTilsAccess[]>([]);
	const [transporterOptions, setTransporterOptions] = useState<ISelectOption[]>([]);
	const [vendorOptions, setVendorOptions] = useState<ISelectOption[]>([]);
	const [customerFilter, setCustomerFilter] = useState<string>("All");
	const [transporterFilter, setTransporterFilter] = useState("All");
	const [vendorFilter, setVendorFilter] = useState("All");

	const [isLoadingTrailers, setIsLoadingTrailers] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const loadTrailersData = async () => {
		setIsLoadingTrailers(true);
		setErrorMessage(undefined);
		setCustomerOptions(userContext.tilsAccess ? userContext.tilsAccess : []);

		const customerIds: string[] = [];
		userContext.tilsAccess?.map((item) => {
			if (item.customerId) {
				customerIds.push(item.customerId.toString());
			}
		});

		TrailerService.getTrailersByCustomers(userContext.id)
			.then((response) => {
				console.log('TrailerService.getTrailersByCustomers: SUCCESS', response);

				let transporters: ISelectOption[] = [];
				let vendors: ISelectOption[] = [];
				let trailers = TrailerService.mapTrailers(response.data);
				trailers.map((item) => {
					if (item.transporterId && !transporters.some(t => t.value == item.transporterId.toString())) {
						transporters.push({ name: item.transporterName, value: item.transporterId.toString() });
					}

					if (item.vendorId && !vendors.some(v => v.value == item.vendorId.toString())) {
						vendors.push({ name: item.vendorName, value: item.vendorId.toString() });
					}

				});

				setGridView(trailers);
				setTransporterOptions(transporters.sort((a, b) => UtilityService.compareStrings(a.name, b.name)));
				setVendorOptions(vendors.sort((a, b) => UtilityService.compareStrings(a.name, b.name)));
			})
			.catch((error) => {
				console.log('TrailerService.getTrailersByCustomers: ERROR', error);
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			})
			.finally(() => {
				setIsLoadingTrailers(false);
			});
	}

	useEffect(() => {
		loadTrailersData();
	}, [])

	return (
		<div className="hwi-trailer-list">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageTrailers}>
					<section className="hwi-entity-search-bar">
						<div className="search-header">
							<div className="title">Trailer Inventory</div>
							<div><NavLink to="/trailer/add"><Button variant="outlined">New Trailer</Button></NavLink></div>
						</div>
						<section className="search-options">
							<FormControl size="small">
								<InputLabel>Customer</InputLabel>
								<Select
									value={customerFilter}
									defaultValue="All"
									label="Customer"
									onChange={(event: SelectChangeEvent) => { setCustomerFilter(event.target.value) }}
								>
									<MenuItem value="All" key="-1">All</MenuItem>
									{customerOptions.map((item, index) => (
										<MenuItem value={item.customerId.toString()} key={index}>{item.customerName}</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl size="small">
								<InputLabel>Vendor</InputLabel>
								<Select
									value={vendorFilter}
									defaultValue="All"
									label="Vendor"
									onChange={(event: SelectChangeEvent) => { setVendorFilter(event.target.value) }}
								>
									<MenuItem value="All" key="-1">All</MenuItem>
									{vendorOptions.map((item, index) => (
										<MenuItem value={item.value.toString()} key={index}>{item.name}</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl size="small">
								<InputLabel>Transporter</InputLabel>
								<Select
									value={transporterFilter}
									label="Transporter"
									onChange={(event: SelectChangeEvent) => { setTransporterFilter(event.target.value) }}
								>
									<MenuItem value="All" key="-1">All</MenuItem>
									{transporterOptions.map((item, index) => (
										<MenuItem value={item.value.toString()} key={index}>{item.name}</MenuItem>
									))}
								</Select>
							</FormControl>

						</section>
					</section>
					<section className="results">
						<Spinner dependency={isLoadingTrailers} text="Loading Trailers...">
							{errorMessage &&
								<Alert className="alert-error"
									severity="error">
									{errorMessage}
								</Alert>
							}
							{!errorMessage &&
								<TrailerTable data={gridView} customer={customerFilter} transporter={transporterFilter} vendor={vendorFilter}></TrailerTable>
							}
						</Spinner>
					</section>
					{/* <Json data={gridView}></Json> */}
				</PermissionGate>
			</Container>
		</div>
	);
};

export default TrailerList;